import React from "react";
import { Link } from "react-router-dom";
import { Trans } from 'react-i18next';
import { useTranslation } from 'react-i18next';

// reactstrap components
import {
  Button,
  NavItem,
  NavLink,
  Nav,
  Container,
  Row,
  Col,
  UncontrolledTooltip,
} from "reactstrap";

export default function Footer() {
  const { t, i18n } = useTranslation();
  return (
    <footer className="footer">    
      <Container>
        <Row>
        <Col md="3" className="container d-flex">
        <div className="divlogo justify-content-center align-self-center">
            <img
                alt="Logo Igreja Conectados"
                className="logo"
                src={require("assets/img/conectados_clara.webp")}
            />       
        </div>
        </Col>   
          <Col md="3">
            <Nav>
              <NavItem>
                <NavLink to="/" tag={Link}>
                  Home
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="#" tag={Link}>
                  <Trans>Ministries</Trans>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/missao-visao-valores" tag={Link}>
                  <Trans>Mission, Vision and Values</Trans>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/nossos-pastores" tag={Link}>
                  <Trans>Our shepherds</Trans>
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col md="3">
            <Nav>
              <NavItem>
                <NavLink to="/contato" tag={Link}>
                  <Trans>Get in touch</Trans>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/seja-membro" tag={Link}>
                  <Trans>Become a member</Trans>
                </NavLink>
              </NavItem>
              <NavItem>
                <NavLink to="/encontre-um-gc" tag={Link}>
                  <Trans>Find a GC</Trans>
                </NavLink>
              </NavItem>
            </Nav>
          </Col>
          <Col md="3" className="justify-content-center align-self-center">
            <h3 className="title"><Trans>Follow us on Instagram</Trans> <Button
                  className="btn-icon btn-neutral btn-round btn-simple"
                  color="default"
                  href="https://instagram.com/igreja.conectados"
                  id="tooltip622135962"
                  target="_blank"
                >
                  <i className="fab fa-instagram" />
                </Button>
                <UncontrolledTooltip delay={0} target="tooltip622135962">
                  <Trans>Follow us on Instagram</Trans>
                </UncontrolledTooltip>
            </h3>
            
              
            
          </Col>
        </Row>
      </Container>
    </footer>
  );
}
